import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { observable, action } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { showSingleAlignmentLayer } from '../AlignmentSummaryTable/AlignmentSummaryTableVM';
import { addAignmentToSummary } from '../IndependentAlignment/IndependentAlignmentVM';
import { AlignmentController } from 'cd-eft/services/eftSetApi';

const alignmentStore = stores.AppStore.alignmentDesignStore;

export interface IAlignmentCopyProps {
  id: string;
  name: any;
}

export class AlignmentCopyVM {
  @observable props;
  constructor(props: any) {
    this.props = props;
    this.initialName = props.name;
    this.copy.id = props.id;
    this.copy.name = props.name.replace('_Centerline', '');
  }

  initialName = '';

  @observable copy = {
    id: 0,
    name: '',
    offset: '',
    number: '',
  };
  @observable formValidation = {
    formErrors: {
      name: '',
    },
  };

  @action.bound handleChange(e) {
    const { name, value } = e.target;
    this.copy[name] = value;
  }

  @action.bound togglePopup() {
    alignmentStore.alignmentCopyModalOpen = !alignmentStore.alignmentCopyModalOpen;
  }

  @action.bound async submitCopy() {
    if (!this.copy.name) {
      this.formValidation.formErrors.name = `You must enter the name of the alignment copy.`;
      return;
    }
    if (!this.copy.number) {
      this.copy.number = '1';
    }
    if (!this.copy.offset) {
      this.copy.offset = '0';
    }
    const postJSON = {
      designElementId: this.copy.id,
      alignmentName: this.copy.name,
      alignmentOffset: Number(this.copy.offset),
      numberOfAlignmentCopies: Number(this.copy.number),
    };
    try {
      alignmentStore.isLoading = true;
      alignmentStore.alignmentCopyModalOpen = false;

      const response = await AlignmentController.duplicateAlignmentsUsingPOST(postJSON);

      if (response.data && response.data.duplicateAlignmentsMap) {
        Object.values(response.data.duplicateAlignmentsMap).forEach((obj) => this.addSingleAlignmentCopy(obj));
      }
      showSingleAlignmentLayer(this.copy.id);
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      alignmentStore.currentTab = 'Summary';
      alignmentStore.isLoading = false;
    }
  }

  @action.bound async addSingleAlignmentCopy(alignment) {
    // replace Id from 0 to designElementName
    alignment.designElementId = alignment.designElementName;
    // add to unsaved set
    alignmentStore.unsavedAlignments.add(alignment.designElementId);
    // add to summary
    addAignmentToSummary(alignment);
  }
}
